import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box, Container, Typography, Paper, Breadcrumbs, Link as MuiLink,
  Divider, Stack, Button, ThemeProvider, CssBaseline, alpha,
} from '@mui/material';
import { Restaurant } from '@mui/icons-material';
import { landingTheme } from '../../theme/landingTheme';

export default function LegalLayout({ title, updated, icon: Icon, children }) {
  return (
    <ThemeProvider theme={landingTheme}>
      <CssBaseline />
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
        <Box sx={{ bgcolor: '#0f172a', color: '#fff', py: 2, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <Container maxWidth="md">
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Button
                component={RouterLink}
                to="/"
                startIcon={<img src="/logo192.png" alt="Logo" style={{ height: 22, width: 22, borderRadius: 4, backgroundColor: '#ffffff', padding: 1 }} />}
                sx={{ color: '#fff', fontWeight: 800, textTransform: 'none', '&:hover': { bgcolor: 'rgba(255,255,255,0.06)' } }}
              >
                Home Billing POS
              </Button>
              <Button component={RouterLink} to="/" sx={{ color: alpha('#fff', 0.75), textTransform: 'none' }}>
                Back to home
              </Button>
            </Stack>
          </Container>
        </Box>

        <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
          <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
            <MuiLink component={RouterLink} to="/" color="inherit" underline="hover">
              Home
            </MuiLink>
            <Typography color="text.primary" fontWeight={600}>{title}</Typography>
          </Breadcrumbs>

          <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 1 }}>
            {Icon ? <Icon color="primary" sx={{ fontSize: 36 }} /> : null}
            <Typography variant="h3" fontWeight={800} color="text.primary" sx={{ fontSize: { xs: '1.75rem', md: '2.25rem' } }}>
              {title}
            </Typography>
          </Stack>
          {updated ? (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {updated}
            </Typography>
          ) : null}

          <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 4, border: '1px solid rgba(0,0,0,0.08)' }}>
            {children}
          </Paper>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 3 }} flexWrap="wrap">
            <Button component={RouterLink} to="/privacy" size="small">Privacy Policy</Button>
            <Button component={RouterLink} to="/terms" size="small">Terms & Conditions</Button>
            <Button component={RouterLink} to="/refund-policy" size="small">Refund Policy</Button>
          </Stack>
        </Container>
      </Box>
    </ThemeProvider>
  );
}

export function Section({ title, children }) {
  return (
    <>
      <Typography variant="h6" fontWeight={700} gutterBottom color="primary.main">
        {title}
      </Typography>
      {children}
      <Divider sx={{ my: 3 }} />
    </>
  );
}

export function P({ children }) {
  return (
    <Typography variant="body1" paragraph color="text.secondary" sx={{ lineHeight: 1.75 }}>
      {children}
    </Typography>
  );
}

export function Ul({ items }) {
  return (
    <Box component="ul" sx={{ pl: 3, mb: 2, color: 'text.secondary' }}>
      {items.map((item, i) => (
        <Box component="li" key={i} sx={{ mb: 1, lineHeight: 1.7 }}>{item}</Box>
      ))}
    </Box>
  );
}
